module.exports = __webpack_public_path__ + "static/media/dataProtection.c7448c92.png";